
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opleidingsaanbod",
      function () {
        return require("private-next-pages/opleidingsaanbod/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opleidingsaanbod"])
      });
    }
  